import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Globe, Menu, X } from "lucide-react";
import { LOGO_URL } from "@/constants/landingAssets";

export default function LandingNav({ t, lang, mobileMenuOpen, setMobileMenuOpen, toggleLang, nextLangLabel, scrollTo, navigate }) {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50" data-testid="landing-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo("hero")}>
            <img src={LOGO_URL} alt="Kaiso" className="w-9 h-9 rounded-lg" />
            <span className="text-xl font-bold text-[#CDA34F]">Kaiso System</span>
          </div>
          <div className="hidden md:flex items-center gap-6">
            <button onClick={() => scrollTo("features")} className="text-sm font-medium text-gray-600 hover:text-[#CDA34F] transition-colors">{t.nav.features}</button>
            <button onClick={() => scrollTo("ai-section")} className="text-sm font-medium text-gray-600 hover:text-[#CDA34F] transition-colors">{t.nav.ia}</button>
            <button onClick={() => scrollTo("integrations")} className="text-sm font-medium text-gray-600 hover:text-[#CDA34F] transition-colors">{t.nav.solutions}</button>
            <button onClick={() => scrollTo("pricing")} className="text-sm font-medium text-gray-600 hover:text-[#CDA34F] transition-colors">{t.nav.pricing}</button>
            <button onClick={toggleLang} className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-[#CDA34F] border border-gray-200 px-2 py-1 rounded-lg" data-testid="lang-toggle">
              <Globe className="w-3.5 h-3.5" />{nextLangLabel[lang]}
            </button>
            <button onClick={() => navigate("/login")} className="text-sm font-medium text-gray-500 hover:text-gray-700" data-testid="nav-login-btn">{t.nav.enter}</button>
            <button onClick={() => navigate("/login")} className="text-sm font-bold text-white bg-[#CC0000] hover:bg-[#a30000] px-4 py-2 rounded-lg uppercase tracking-wide transition-colors" data-testid="nav-cta-btn">{t.nav.cta}</button>
          </div>
          <div className="flex md:hidden items-center gap-2">
            <button onClick={toggleLang} className="text-xs font-medium text-gray-500 border border-gray-200 px-2 py-1 rounded" data-testid="lang-toggle-mobile">{nextLangLabel[lang]}</button>
            <button className="p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>{mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}</button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t px-4 pb-4 space-y-3">
          <button onClick={() => scrollTo("features")} className="block w-full text-left py-2 text-gray-600">{t.nav.features}</button>
          <button onClick={() => scrollTo("ai-section")} className="block w-full text-left py-2 text-gray-600">{t.nav.ia}</button>
          <button onClick={() => scrollTo("pricing")} className="block w-full text-left py-2 text-gray-600">{t.nav.pricing}</button>
          <Button onClick={() => navigate("/login")} className="w-full bg-[#CDA34F] hover:bg-[#b8903e] text-white">{t.nav.enter}</Button>
        </div>
      )}
    </nav>
  );
}
